<template>
  <Payment>
    <template #logo>
      <img :src="require(`@/assets/images/bulle-${status}.png`)" alt />
    </template>
    <b-jumbotron
      bg-variant="transparent"
      text-variant="primary"
      border-variant="transparent"
      class="border-0"
      header-tag="div"
    >
      <template #header>
        <h1 class="text-center font-size-48" style="font-weight: 700">{{ title[status] }}</h1>
      </template>
      <b-container class="mt-4">
        <div class="text-center font-size-24">
          {{ text }}
        </div>
      </b-container>
    </b-jumbotron>
    <b-container>
      <div class="d-flex justify-content-center">Vous pouvez fermer la fenêtre</div>
    </b-container>
  </Payment>
</template>

<script>
import Payment from '@/router/layouts/payment.vue'

export default {
  components: {
    Payment,
  },
  props: {
    status: String,
    title: Object,
    text: String,
  },
}
</script>
